import React from 'react';
import { Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../theme';
import Reveal from './Reveal';

const useStyles = makeStyles((theme) => ({
  section: {
    padding: theme.spacing(10, 0),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(7, 0),
    },
  },
  white: { backgroundColor: '#FFFFFF' },
  sand: { backgroundColor: colors.sand },
  navy: { backgroundColor: colors.navy, color: '#FFFFFF' },
  header: {
    textAlign: 'center',
    maxWidth: 680,
    margin: '0 auto',
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(4),
    },
  },
  eyebrow: {
    color: colors.green,
    display: 'block',
    marginBottom: theme.spacing(1),
  },
  eyebrowOnDark: {
    color: colors.gold,
  },
  subtitle: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  subtitleOnDark: {
    color: 'rgba(255,255,255,0.8)',
  },
}));

// A full-width page section with an optional centered heading.
export default function Section({ id, background = 'white', eyebrow, title, subtitle, children }) {
  const classes = useStyles();
  const dark = background === 'navy';

  return (
    <section id={id} className={`${classes.section} ${classes[background]}`}>
      <Container maxWidth="lg">
        {title && (
          <Reveal>
            <div className={classes.header}>
              {eyebrow && (
                <Typography
                  variant="overline"
                  component="span"
                  className={`${classes.eyebrow} ${dark ? classes.eyebrowOnDark : ''}`}
                >
                  {eyebrow}
                </Typography>
              )}
              <Typography variant="h3" component="h2">
                {title}
              </Typography>
              {subtitle && (
                <Typography
                  variant="subtitle1"
                  className={`${classes.subtitle} ${dark ? classes.subtitleOnDark : ''}`}
                >
                  {subtitle}
                </Typography>
              )}
            </div>
          </Reveal>
        )}
        {children}
      </Container>
    </section>
  );
}
